/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Injectable} from '@angular/core';
import {AlertsColumnEnum} from '../../models/alerts-column.enum';
import {SortDirection} from '../../../../../api/generic/contracts/sort-direction.enum';
import {AbstractSearchCriteriaService} from '../../../../../shared/filter/abstract-search-criteria.service';
import {AlertConfigQueryContract} from '../../../../../api/ms-settings/alerts-config/contracts/alert-config-query.contract';
import {AlertConfigSearchCriteriaContract} from '../../../../../api/ms-settings/alerts-config/contracts/alert-config-search-criteria.contract';
import {CodeFilterStateModel} from '../../../../../shared/filter/code-filter/code-filter-state.model';
import {AlertsActiveEnum} from '../../models/alerts-active.enum';
import {TableSortedByModel} from '../../../../../shared/table/models/table-sorted-by.model';

@Injectable({
    providedIn: 'root'
})

export class AlertsConfigSearchCriteriaService extends AbstractSearchCriteriaService<AlertsColumnEnum> {
    initiallySortedBy: TableSortedByModel<AlertsColumnEnum> = {
        code: AlertsColumnEnum.UPDATED_ON,
        direction: SortDirection.DESC
    };

    clear(): void {
        // clear stored filters
        this.stateMap.clear();

        // Sort criteria
        this.sortDirection = SortDirection.DESC;
        this.sortedBy = AlertsColumnEnum.UPDATED_ON;

        // Pagination
        this.pageSize = 20;
        this.pageNumber = 1;
        this.totalResults = 0;
    }

    getAlertsConfigQuery(hasPaginationCriteria?: boolean): AlertConfigQueryContract {
        const searchCriteria: AlertConfigSearchCriteriaContract = {
            name: this.mapStringCriterion(AlertsColumnEnum.NAME),
            description: this.mapStringCriterion(AlertsColumnEnum.DESCRIPTION),
            startsOn: this.mapNullableDateCriterion(AlertsColumnEnum.STARTS_ON),
            endsOn: this.mapNullableDateCriterion(AlertsColumnEnum.ENDS_ON),
            createdBy: this.mapStringCriterion(AlertsColumnEnum.CREATED_BY),
            createdOn: this.mapDateCriterion(AlertsColumnEnum.CREATED_ON),
            updatedBy: this.mapStringCriterion(AlertsColumnEnum.UPDATED_BY),
            updatedOn: this.mapDateCriterion(AlertsColumnEnum.UPDATED_ON),
            active: this.mapActiveCriterion()
        };

        return {
            searchCriteria,
            paginationCriteria: hasPaginationCriteria ? this.paginationCriteria : this.resetPaginationCriteria
        };
    }

    private mapActiveCriterion(): boolean {
        const filterValue = <CodeFilterStateModel> this.stateMap.get(AlertsColumnEnum.ACTIVE);
        const activeChecked = filterValue?.filteredCodes?.find((entry) =>
                entry.code === AlertsActiveEnum.ACTIVE).checked;
        const inactiveChecked = filterValue?.filteredCodes?.find((entry) =>
                entry.code === AlertsActiveEnum.INACTIVE).checked;
        const allChecked = filterValue?.all;
        if (!allChecked && (activeChecked !== inactiveChecked)) {
            return activeChecked;
        }
    }
}
